'use client'
import MessagesContext from './MessagesContext'
import { useContext } from 'react'
export default function useMessageContext() {
  return useContext(MessagesContext)
}
